module.exports = __webpack_public_path__ + "lv.svg?2b8d0b5bc8dc03220f25a71adb9a9070";